  var _learnq = _learnq || [];
  window.addEventListener('DOMContentLoaded', function(event) {
      var elements = window.frames.document.getElementsByClassName('add-to-cart-ajax');
      var learnq = learnq || [];
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", function(event) {
         var currentproducthandle = $(this).closest("form").find('input[name="id"]').attr("data-producthandle");
         var currentvariationid = $(this).closest("form").find('input[name="id"]').val();
            $.ajax({
            dataType: "json",
            async: false,
            url:"https://www.trulybeauty.com/products/" + currentproducthandle + ".js",
            success: function (data) {
              for (var i = 0; i < data.variants.length; i++) {
                if (data.variants[i]["id"] == currentvariationid) {
                    price = (data.variants[i].price / 100).toFixed(2);
                    compare_at_price = (data.variants[i].compare_at_price / 100).toFixed(2);
                    sku = data.variants[i].sku;
                    item_variant = data.variants[i].id;
                }
              }
              var item = {
                  Name: data.title,
                  ProductID: data.id,
                  Categories: data.type,
                  ImageURL: data.featured_image,
                  URL: "https://www.trulybeauty.com/products/" + data.handle,
                  Brand: data.vendor,
                  Price: price,
                };
                _learnq.push(['track', 'Added to Cart', item]);
            },
          });  
        });
      }
    });


//google dynamic remarketing tag for theme.liquid -->

    var google_tag_params = {
      ecomm_pagetype: 'other'
    };


//Google Tag Code -->
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('event', 'page_view', {'send_to': 'AW-696735408',
                              'ecomm_prodid':window.google_tag_params.ecomm_prodid,
                              'ecomm_pagetype': window.google_tag_params.ecomm_pagetype,
                              'ecomm_totalvalue':window.google_tag_params.ecomm_totalvalue
                             });

//Google Analytics Code -->
  window.addEventListener('load', function(){
    jQuery('button.add-to-cart-ajax').click(function(){
      ga('send','event','button','click','add to cart');
    });
    jQuery('input[value="Continue to Checkout"]').click(function(){
      ga('send','event','button','click','continue to checkout');
    });
  });